export default __webpack_public_path__ + "static/media/crpto.4c715d07.webp";